/**
 * Popover theme
 * @see https://github.com/chakra-ui/chakra-ui/blob/v2/packages/theme/src/components/popover.ts
 */
import { popoverAnatomy as parts } from '@chakra-ui/anatomy';
import { cssVar, } from '@chakra-ui/styled-system';
import { textStyles } from '../textStyles';
import { getChakraVarExpression } from '../utils/chakraVar';
const $arrowShadowColor = cssVar('popper-arrow-shadow-color');
export const Popover = {
    parts: parts.keys,
    baseStyle: {},
    variants: {
        tooltip() {
            return {
                content: {
                    ...textStyles.body2,
                    w: 'auto',
                    maxW: '100vw',
                    bg: 'brand.secondary-dark-blue',
                    color: 'brand.white',
                    rounded: '8px',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'brand.gray-scale-border-10',
                    [$arrowShadowColor.variable]: getChakraVarExpression('colors', 'brand.gray-scale-border-10'),
                },
                body: {
                    px: '12px',
                    py: '8px',
                },
                arrow: {
                    bg: 'brand.secondary-dark-blue!important',
                },
            };
        },
    },
    sizes: {},
    defaultProps: {},
};
